import { css } from 'styled-components';
import { focusCssRule } from './focus';

// TODO: PUBWEB-2036 replace TabThemeValues with Theme type
interface TabThemeValues {
  tabColor: string;
  tabActiveColor: string;
  tabActiveBorder: string;
}

interface TabSharedCssParams {
  active: boolean;
  theme: TabThemeValues;
}

const tabSharedCss = ({ active, theme }: TabSharedCssParams) => {
  let tabCss;

  if (!active) {
    tabCss = css`
      color: ${theme.tabColor};
    `;
  } else {
    tabCss = css`
      color: ${theme.tabActiveColor};
      position: relative;
      /** Use ::after to set border to ensure this shows up with Contrast Themes and focus indicator isn't wonky */
      &::after {
        content: '';
        position: absolute;
        bottom: -5px;
        left: 0;
        width: 100%;
        border-bottom: ${`5px solid ${theme.tabActiveBorder}`};
        pointer-events: none;
      }
    `;
  }

  return css`
    margin-bottom: 5px;
    ${tabCss}
    ${focusCssRule({ type: 'inset' })}
  `;
};

export default tabSharedCss;
